import React from "react";
import { Link } from "react-router-dom";
import "./NoPage.scss";

const NoPage = () => {
  return (
    <div className="NotFound">
      <div className="notfound-content">
        <h1>404</h1>
        <h2>Oops! Page Not Found</h2>
        <p>
          Looks like you’ve wandered off track! <br />
          The page you’re looking for doesn’t exist or may have been moved.
        </p>

        <Link to="/" className="home-btn">
          Back to Home
        </Link>

        <span className="brand-footer">— V-Ex Tech Solution</span>
      </div>
    </div>
  );
};

export default NoPage;
